module.exports = __webpack_public_path__ + "static/media/pulverizador2.009ec857.svg";